module.exports = __webpack_public_path__ + "img/1004qhs.9da00086.png";